'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Header = require('./Header/Header.js');
var Login = require('./Login.js');
require('../../styles/index.scss.js');
require('../../../node_modules/react-responsive-modal/styles.css.js');
var Button = require('../Button/Button.js');
require('../../../node_modules/classnames/index.js');
require('../ButtonGroup/ButtonGroup.scss.js');
require('../Badge/Badge.scss.js');
require('../Label/Label.scss.js');
require('../Checkbox/Checkbox.scss.js');
require('../Icon/Icon.scss.js');
require('../Button/helper.scss.js');
require('../Switch/Switch.scss.js');
require('../Radio/Radio.scss.js');
var Input = require('../Input/Input.js');
require('../Loader/Loader.scss.js');
require('../Footer/Footer.scss.js');
require('../Navbar/Navbar.js');
require('../Navbar/MobileNavigation/styles.scss.js');
require('../../../node_modules/pure-react-carousel/dist/index.es.js');
require('../Carousel/Carousel.scss.js');
require('../../../node_modules/pure-react-carousel/dist/react-carousel.es.css.js');
require('../Pagination/Pagination.scss.js');
require('../Modal/Modal.scss.js');
require('../DropDown/DropDown.scss.js');
require('../Accordion/AccordionGroup.js');
require('../Accordion/AccordionIcon.scss.js');
require('../Accordion/Accordion.scss.js');
require('../Stepper/Stepper.scss.js');
require('../Tabs/Tabs.scss.js');
require('../BottomNavigation/FooterNavigation/Tools/Tools.scss.js');
require('../BottomNavigation/FooterNavigation/Insurance/Insurance.scss.js');
require('../BottomNavigation/FooterNavigation/Account/Account.scss.js');
require('../BottomNavigation/FooterNavigation/Explore/Explore.scss.js');
require('../BottomNavigation/FooterNavigation/FooterNavigation.scss.js');
require('../../utils/hooks/canUseWebp.js');
require('../BottomNavigation/BottomNavigation.scss.js');
require('../ViewMore/ViewMore.scss.js');
require('../MFELogin/index.js');
require('../Swiper/index.js');
require('../Alert/Alert.scss.js');
require('../Loader/LifepalLoader.js');
require('../SEOAccordion/SEOAccordion.scss.js');
require('../Skeleton/index.js');
require('../LifepalProvider/LifepalProvider.js');
require('react-dom');
require('../../../node_modules/react-responsive-modal/node_modules/classnames/index.js');
require('../../../node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js');
require('../ResponsiveModal/style.scss.js');
require('../Card/Card.js');
var index = require('./LockedUserMessage/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var LoginEmailForm = function (props) {
    var previous = props.previous, isModal = props.isModal;
    var _a = Login.useLoginContext(), goToRegister = _a.goToRegister, goToForgetPassword = _a.goToForgetPassword, errorMessage = _a.errorMessage, loginWithEmail = _a.loginWithEmail, backToPrev = _a.backToPrev, isUserLocked = _a.isUserLocked;
    var _b = React.useState(''), email = _b[0], setEmail = _b[1];
    var _c = React.useState(''), password = _c[0], setPassword = _c[1];
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        !isModal && React__default['default'].createElement(Header, { showBackBtn: true, isModal: isModal, onBackBtnClick: function () { return backToPrev(previous); } }),
        React__default['default'].createElement("div", { className: isModal ? 'form--modal' : 'form' },
            isModal && React__default['default'].createElement(Header, { showBackBtn: true, isModal: isModal, onBackBtnClick: function () { return backToPrev(previous); } }),
            isUserLocked && React__default['default'].createElement(index, null),
            React__default['default'].createElement(Input.Input, { id: 'input-email', name: 'input-email', type: 'text', inputMode: 'text', value: email, size: 'lg', placeholder: 'Email / No. Telp', onChange: function (e) { setEmail(e.target.value); }, className: "" + ((errorMessage && errorMessage.email) ? 'input-error' : 'bottom-18p') }),
            errorMessage && errorMessage.email &&
                React__default['default'].createElement("p", { className: 'text-error bottom-18p top-5p' }, errorMessage.email),
            React__default['default'].createElement("div", { className: 'input-password' },
                React__default['default'].createElement(Input.Input, { id: 'input-password', name: 'input-password', type: 'password', inputMode: 'text', value: password, size: 'lg', placeholder: 'Password', onChange: function (e) { setPassword(e.target.value); }, className: (errorMessage && errorMessage.password) ? 'input-error' : ' bottom-8p' })),
            errorMessage && errorMessage.password &&
                React__default['default'].createElement("p", { className: 'text-error bottom-8p top-5p' }, errorMessage.password),
            goToForgetPassword &&
                React__default['default'].createElement("div", { className: 'bottom-16p text-right forgot-password' },
                    React__default['default'].createElement("span", { id: 'redirect-to-forget-password', onClick: goToForgetPassword }, "Lupa Password?")),
            React__default['default'].createElement(Button.Button, { id: 'button-login', className: 'action-button bottom-16p', onClick: function () { loginWithEmail({ email: email, password: password }); } }, "Masuk"),
            goToRegister &&
                React__default['default'].createElement("div", { className: 'text-center register-now' },
                    React__default['default'].createElement("span", null, "Belum Punya Akun?"),
                    React__default['default'].createElement("span", { id: 'redirect-to-register', onClick: goToRegister, className: 'go_to_regis' }, " Daftar Sekarang")))));
};

exports.LoginEmailForm = LoginEmailForm;
//# sourceMappingURL=LoginEmailForm.js.map
